import { TextField } from "@mui/material";
import { useState, useContext } from "react";

import { ChatContext } from "../../contexts/chat/context";

export const InputContainer = () => {
  const { sendMessage, isAwaitingResponse, agentState } = useContext(ChatContext);
  const [inputValue, setInputValue] = useState("");

  // Disable input while agent is processing
  const isDisabled = isAwaitingResponse || agentState.status === "streaming";

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSendMessage();
    }
  };

  const handleSendMessage = () => {
    if (inputValue.trim() && !isDisabled) {
      sendMessage(inputValue);
      setInputValue("");
    }
  };

  return (
    <TextField
      fullWidth
      multiline
      maxRows={4}
      placeholder={isDisabled ? "Waiting for response..." : "What would you like to do?"}
      value={inputValue}
      onChange={handleInputChange}
      onKeyPress={handleKeyPress}
      variant="outlined"
      size="small"
      disabled={isDisabled}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: "100%",
          alignItems: "flex-start",
          backgroundColor: isDisabled ? "#f5f5f5" : "#fff",
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e0e0e0",
            boxShadow: "none",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e0e0e0",
            borderWidth: "1px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e0e0e0",
            borderWidth: "1px",
          },
          "&.Mui-disabled": {
            backgroundColor: "#f5f5f5",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#e0e0e0",
            },
          },
          "& textarea": {
            height: "100% !important",
          },
        },
      }}
    />
  );
};
